export default "__VITE_ASSET__CkZBe4M7__"